<template>
    <div class="con animated fadeInDown" :class="{'dark':active2}">
        <div class="main">
            <a href="/home.html"> <img class="a" src="../assets/home/amt_logo.png" alt=""></a>
            <a href="/home.html"> <img class="b" src="../assets/amt_logow.png" alt="" ></a>
            <ul>
                <!--                <li v-for="(item,home) in list" :key="home" @click="goto(home)" :class="{'showLine':select===home}">{{item}}</li>-->
                <a href="/home.html" :class="page === 'home' ? 'showLine' : ''"> <li >{{$t('top[0]')}}</li></a>
                <a href="/about.html" :class="page === 'about' ? 'showLine' : ''"><li >{{$t('top[1]')}}</li></a>
                <!-- <a href="/pro.html" :class="page === 'pro' ? 'showLine' : ''"> <li >{{$t('top[2]')}}</li></a> -->
                <a href="/prolist.html" :class="page === 'prolist' ? 'showLine' : ''"> <li >{{$t('top[2]')}}</li></a>
                <a href="/news.html" :class="page === 'news' ? 'showLine' : ''"><li >{{$t('top[3]')}}</li></a>
                <a href="/human.html" :class="page === 'human' ? 'showLine' : ''"><li >{{$t('top[4]')}}</li></a>
                <a href="/tele.html" :class="page === 'tele' ? 'showLine' : ''"><li >{{$t('top[5]')}}</li></a>
                <a href="/contact.html" :class="page === 'contact' ? 'showLine' : ''"><li >{{$t('top[6]')}}</li></a>
            </ul>
            <div class="right">
               <i class="iconfont icon-search" @click="searchShow=!searchShow"></i>
                <a href="https://qiye.aliyun.com/" target="_blank">
                    <i class="iconfont icon-youxiang"></i>
                </a>
<!--                <el-select v-model="value" placeholder="请选择"  @change="getlan">-->
<!--                    <el-option-->
<!--                            v-for="item in options"-->
<!--                            :label="item.label"-->
<!--                            :value="item.value"-->
<!--                            :key="item.value"-->
<!--                    >-->
<!--                    </el-option>-->
<!--                </el-select>-->
                <div class="ball">
                    <span @click="showLan">
                          <i class="iconfont icon-diqiu"></i>
                    </span>
                    <div :class="{'showlan':showTwo}">
                        <img src="../assets/china.svg" alt="" @click="changeLan2('zh-CN')">
                        <img src="../assets/am.svg" alt="" @click="changeLan2('en')">
                    </div>
                </div>
            </div>
        </div>
        <div class="sea" :class="{'animated zoomIn':searchShow===true,'animated zoomOutDown':searchShow===false,'noShow':searchShow===0}">
            <div style="position: absolute;height:100%;width:100%;z-index: -1;top:0;left: 0;background-color: rgba(0, 131, 255, .5);" @click="searchShow=false;input=''">
            </div>
            <div class="ma">
                <input style="z-index: 1;" type="text" v-model="input" :placeholder="$t('search')"  @keyup.enter="gotoSearch">
                <i class="iconfont icon-search"  @click="gotoSearch"></i>
            </div>

        </div>
        <div class="top animated fadeInUp">
            <a href="/home.html"> <img class="a" src="../assets/home/amt_logo.png" alt=""></a>
            <a href="/home.html"> <img class="b" src="../assets/amt_logow.png" alt="" ></a>
            <div class="mNav" :class="{active: menuOpen}" @click="menuOpen=!menuOpen">
                <span class="burger"></span>
                <span class="burger"></span>
                <span class="burger"></span>
            </div>
        </div>
        <div class="menuBox" :class="{open: menuOpen}">
            <a href="/home.html" :class="page === 'home' ? 'showLine' : ''"> <li >{{$t('top[0]')}}</li></a>
            <a href="/about.html" :class="page === 'about' ? 'showLine' : ''"><li >{{$t('top[1]')}}</li></a>
            <!-- <a href="/pro.html" :class="page === 'pro' ? 'showLine' : ''"> <li >{{$t('top[2]')}}</li></a> -->
            <a href="/prolist.html" :class="page === 'prolist' ? 'showLine' : ''"> <li >{{$t('top[2]')}}</li></a>
            <a href="/news.html" :class="page === 'news' ? 'showLine' : ''"><li >{{$t('top[3]')}}</li></a>
            <a href="/human.html" :class="page === 'human' ? 'showLine' : ''"><li >{{$t('top[4]')}}</li></a>
            <a href="/tele.html" :class="page === 'tele' ? 'showLine' : ''"><li >{{$t('top[5]')}}</li></a>
            <a href="/contact.html" :class="page === 'contact' ? 'showLine' : ''"><li >{{$t('top[6]')}}</li></a>
            <div class="language">
                <span @click="changeLan('zh-CN')">中文</span>
                <span @click="changeLan('en')">ENGLISH</span>
            </div>
        </div>
    </div>
</template>

<script>
    import Scrollbar from 'smooth-scrollbar';
    import { setup } from "../local/index"
    export default {
        name: "first",
        data(){
            return{
                showTwo:false,
                input:'',
                searchShow:0,
                options: [{
                    value: 'a',
                    label: 'EN'
                }, {
                    value: 'b',
                    label: 'CN'
                }],
                value: '',
                showa:true,
                select:0,
                menuOpen:false,
                active2:false,
                scrollbar:'',
                top:'',
                list:[
                    "首页",
                    "走进澳玛特",
                    "产品与方案",
                    "新闻媒体",
                    "NEW ARRIVALS",
                    "CONTACT US",
                ]
            }
        },
        props:['page'],
        // watch: {
        //     $route: 'getScrollbar'
        // },
        mounted(){
            this.$nextTick(()=>{
                this.getScrollbar()
                if(this.$i18n.locale ==='en'){
                    this.value='a'
                }else{
                    this.value='b'
                }
            })
        },
        methods:{
            showLan(){
                this.showTwo=!this.showTwo
            },
            gotoSearch(){
                const link = `/pros.html?name=${this.input}`
                window.open(link,'_blank')
                this.searchShow=false
                this.input=''
            },
            changeLan2(n){
                this.showTwo=false
                setTimeout(()=>{
                    this.$i18n.locale = n
                    window.localStorage.setItem('language', n)
                    setup(n);
                    window.location.reload()
                },600)

            },
            changeLan(n){
                this.menuOpen=false
                setTimeout(()=>{
                    this.$i18n.locale = n
                    window.localStorage.setItem('language', n)
                    setup(n);
                    window.location.reload()
                },600)

            },
            getlan(){
                if(this.value==='a'){
                    this.$i18n.locale = 'en'
                    window.localStorage.setItem('language', 'en')
                    setup('en');
                    window.location.reload()
                }else{
                    this.$i18n.locale = 'zh-CN'
                    window.localStorage.setItem('language', 'zh-CN')
                    setup('zh-CN');
                    window.location.reload()
                }
            },
            goto(n){
                this.select=n
                this.menuOpen=false
                this.showa=false
                localStorage.setItem('index',n)
                if(n===0){
                    this.$router.push({path:'/home'})
                }else if(n===1){
                    this.$router.push({path:'/about'})
                }else if(n===2){
                    this.$router.push({path:'/pro'})
                } else if(n===3){
                    this.$router.push({path:'/news'})
                } else if(n===4){
                    this.$router.push({path:'/human'})
                }else{
                    this.$router.push({path:'/contact'})
                }
                // else if(n===4){
                //     this.$router.push({path:'/news'})
                // }else if(n===6){
                //     this.$router.push({path:'/contact'})
                // }else if(n===5){
                //     this.$router.push({path:'/human'})
                // }else {
                //     this.$router.push({path:'/about'})
                // }
            },
            scrollHeader(scrollTop){
                this.active2=scrollTop>200 ? true : false
            },
            getScrollbar(){
                this.$nextTick(()=>{
                    this.scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
                    this.active2=false
                    // this.showa=true
                    this.select=parseInt(localStorage.getItem('index'))
                    let scrollHeader=this.scrollHeader
                    if(this.scrollbar){
                        this.scrollbar.addListener((status) => {
                            scrollHeader(status.offset.y)
                        });
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .con{
        width:100%;
        position: fixed;
        top:0;
        left:0;
        z-index: 1000;
        transition: all 600ms;
        border-bottom: 1px solid rgba(255,255,255,.3);
        .sea{
            position: fixed;
            left: 0;
            height:60px;
            width:100%;
            top:0;
            text-align: center;
            padding-top: 30px;
            .ma{
                width:300px;
                margin: 0 auto;
                input{
                    width:300px;
                    height:30px;
                    border-radius: 20px;
                    border: none;
                    border-bottom: 1px solid white;
                    text-indent: 30px;
                }
                input:focus{
                    outline: none;
                }
                i{
                    margin-left: -40px;
                    cursor: pointer;
                }
            }
        }
        .noShow{
            display: none;
        }
        .main{
            width:90%;
            margin-left: 5%;
            display: flex;
            flex-direction: row;
            transition: all 600ms;
            img{
                height:30px;
                width:173px;
                margin-top:30px;
                cursor: pointer;
            }
            .a{
                display: block;
                transition: all 600ms;
            }
            .b{
                display: none;
                transition: all 600ms;
            }
            ul{
                list-style: none;
                display: flex;
                flex-direction: row;
                color:white;
                justify-content: space-between;
                width:70%;
                margin-left: 5%;
                margin-top: 10px;
                a{
                    color:white;
                    transition: all 2s;
                    padding-top: 30px;
                    position: relative;
                    padding-bottom: 30px;
                    font-size: 14px;
                      li{
                          transition: all 2s;
                          color:white;
                          text-transform: uppercase;
                      }
                }
                a:hover{
                    li{
                        color:#F7BC30;
                    }
                }
                a::before{
                    content:'';
                    position: absolute;
                    left:0;
                    bottom:0;
                    width:0;
                    height:1px;
                    background-color: #F5AC01;
                    display: inline-block;
                    border-radius: 10px;
                    transition: all 600ms;
                }
                a:hover::before{
                    width:100%;
                }
                .showLine{
                    li{
                        color:#F7BC30;
                    }
                }
                .showLine::before{
                    width:100%;
                }
            }
            .right{
                display: flex;
                flex-direction: row;
                margin-left: 5%;
                color:white;
                align-items: center;
                padding-top: 10px;
                i{
                    font-size: 22px;
                    cursor: pointer;
                    transition: all 1s;
                }
                i:hover{
                    color:#F5AC01;
                }
                a{
                    margin-left: 25px;
                    i{
                        font-size: 28px;
                        cursor: pointer;
                        color:white;
                    }
                }
                .ball{
                    width:100px;
                    text-align: center;
                    position: relative;
                    span{
                        display: inline-block;
                        animation: run2  2s linear infinite;
                        i{
                            font-size: 25px;
                            transition: all 1s;
                        }
                    }
                    span:hover,span:active,span:focus{
                        i{
                            color:#0673DA;
                        }
                    }
                    div{
                        position: absolute;
                        width:100%;
                        top:50px;
                        left:0;
                        display: flex;
                        flex-direction: column;
                        background-color: white;
                        padding-bottom: 10px;
                        border-radius: 10px;
                        opacity: 0;
                        transition: all 600ms;
                        img{
                            width:100%;
                            margin-top: 10px;
                            height:25px;
                            transition: all 600ms;
                        }
                        img:hover{
                            transform: scale(1.05);
                        }
                    }
                    .showlan{
                        opacity: 1;
                    }
                    @keyframes run2 {
                        from{
                            transform: rotate(0);
                        }
                        to{
                            transform: rotate(360deg);
                        }
                    }
                }
            }
        }
        .top{
            display: none;
        }
        .menuBox{
            position: fixed;
            top: 70px;
            right:-100%;
            height:100vh;
            width: 100%;
            background:#0673DA;
            z-index: 1010;
            transition: .8s;
            padding-top: 0;
            display: block;
        }
        .menuBox a{
            display: block;
            font-size: 18px;
            color:white;
            width:80%;
            padding: 18px 0px;
            text-align: center;
            opacity: 0;
            transition: .8s;
            li{
                color:white;
                list-style: none;
            }
        }
        .menuBox .language{
            width:80%;
            display: flex;
            flex-direction: row;
            justify-content: center;
            color:white;
            align-items: center;
            font-size: 18px;
            margin-top: 10px;
            span{
                padding: 0 10px;
            }
        }
        .menuBox.open{
            padding-top: 30px;
            right:-25%;
            a{
                opacity: 1;
            }
        }
        @media screen and (min-width: 2200px){
            .main{
                ul{
                    width:75%;
                }
            }
        }
        @media screen and (max-width: 1440px){
            .main{
                width:100%;
                margin-left: 2%;
                ul{
                    width:65%;
                }
                .right{
                    margin-left: 3%;
                    padding-top: 0;
                }
            }
        }
        @media screen and (max-width:450px){
            .main{
                display: none;
            }
            .top{
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                width:100%;
                padding: 20px 0px;
                transition: all 2s;
            }
            .a{
                height:30px;
                object-fit: cover;
                margin-left: 40%;
                display: block;
                transition: all 600ms;
            }
            .b{
                height:30px;
                object-fit: cover;
                margin-left: 40%;
                display: none;
                transition: all 600ms;
            }
            .mNav{
                display: block;
                transition: .8s;
                position: absolute;
                right: 0;
                top: 0;
                bottom: 0;
                width: 60px;
            }
            .mNav .burger{
                width: 32px;
                height: 4px;
                background-color: white;
                position: absolute;
                top: 25px;
                left: 50%;
                margin: 0px 0px 0px -16px;
                transform-origin: center;
                transition: .8s;
            }
            .mNav .burger:nth-of-type(2){
                top: 35px;
            }
            .mNav .burger:nth-of-type(3){
                top: 45px;
            }
            .mNav.active{
                background-color:#0673DA;
            }
            .mNav.active .burger{
                background-color: #fff;
            }
            .mNav.active .burger:nth-of-type(1){
                top: 35px;
                transform: rotate(225deg);
            }
            .mNav.active .burger:nth-of-type(2){
                left: -100%;
                opacity: 0;
            }
            .mNav.active .burger:nth-of-type(3){
                top: 35px;
                transform: rotate(-225deg);
            }
        }
    }
    .dark{
        background-color: white;
        .main{
            .a{
            display: none;
        }
            .b{
                display: block;
            }
            ul{
                a{
                    li{
                        color:black;
                    }
                }
            }
            .right{
                i{
                    color:black !important;
                }
            }
        }
        @media screen and (max-width:450px){
          .top{
              a:nth-child(1){
                  display: none;
              }
          }
            .b{
                display: block;
            }
            .mNav .burger{
                background-color: #0C3665;
            }
        }
    }
</style>
<style>
    .el-input{
        margin-top: 0 !important;
    }
    .el-input__inner{
        background-color: transparent !important;
        border: none  !important;
        color:rgba(0,0,0,.5) !important;
    }
</style>